export default __webpack_public_path__ + "codeigniter.c74fdf61.png";